import {ImmutableObject} from '../../utils/immutableObject';
import {Big} from 'big.js';
import {bigToString, parseBig} from '../../utils/math-utils';
import {EnumCorridorColor, getColorFromString} from '../enum/enum-corridor-color';
import {EnumDisplayMode} from '../enum/enum-display-mode';
import {QuoteService} from './quote-service';
import {EnumQuoteServiceSalesType} from '../enum/enum-quote-service-sales-type';
import {BillingLine} from '../billing-line/billing-line.model';

export class ServiceLine extends ImmutableObject {

    public readonly code?: string;

    public readonly newQuoteService?: QuoteService;
    public readonly existingQuoteService?: QuoteService;
    public readonly renewalQuoteService?: QuoteService;

    public readonly appliedPrice?: string;
    public readonly appliedPriceColor?: string;
    public readonly isSelected?: boolean;
    public readonly order?: number;
    public readonly isEnabled?: boolean;
    public readonly synthesisViews: any[] = [];
    public readonly displayMode?: EnumDisplayMode;
    public readonly billingLines?: BillingLine[];

    constructor(
    ) {
        super();
    }

    get weeklyAmount(): string {
        if(this.displayMode === EnumDisplayMode.MONTHLY)
        {
            return bigToString(parseBig(this.monthlyAmount).div(new Big("4.348")));
        }
        return this.appliedPrice;
    }

    get monthlyAmount(): string {
        if(this.displayMode === EnumDisplayMode.WEEKLY){
            return  bigToString(parseBig(this.appliedPrice).mul(new Big("4.348")));
        }
        return this.appliedPrice;
    }


    get existingMonthlyAmount(): string {
        return this.existingQuoteService ? this.existingQuoteService.monthlyAmount : '0.00';
    }


    get serviceLineColor(): EnumCorridorColor {
        return getColorFromString(this.appliedPriceColor);
    }

    isServiceLineValid(isDisco: boolean): boolean {
        return this.newQuoteService ? this.newQuoteService.isQuoteServiceValid(isDisco) : true;
    }

    getQuoteServiceBySalesType(salesType: EnumQuoteServiceSalesType): QuoteService {
        switch (salesType) {
            case EnumQuoteServiceSalesType.EXISTING:
                return this.existingQuoteService;
            case EnumQuoteServiceSalesType.RENEWAL:
                return this.renewalQuoteService;
            case EnumQuoteServiceSalesType.NEW:
                return this.newQuoteService
        }
    }

    hasAtLeastOnePricingItem() {
        return this.renewalQuoteService?.productPricingItems?.length > 0 || this.newQuoteService?.productPricingItems?.length > 0;
    }


    get variationPrice(): string {
        let total: Big = new Big(this.monthlyAmount).minus(new Big(this.existingMonthlyAmount));
        return bigToString(total);
    }

    hasPricingItemsWithQuantity(): boolean {
        return this.newQuoteService?.hasPricingItemsWithQuantity() || this.renewalQuoteService?.hasPricingItemsWithQuantity()
    }

    isServicePriced(): boolean {
        return this.renewalQuoteService?.isServicePriced() || this.newQuoteService?.isServicePriced();
    }

}
